<template>
  <h1 class="text-title-1 font-extrabold">
    <slot />
  </h1>
</template>

<style>
.text-title-1 {
  @apply text-[24px] md:text-[32px] xl:text-[42px] leading-[1.1];
}
</style>